// @flow
import { setIsDirty, setResourceSettings } from 'pages/Slices/packetSlice'
import { contextNames } from 'pages/Utils/extra-contexts'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'

type Props = {
  children: Function,
}

function FormBuilderSettingsCustomInvitePacketConsumer({
  children,
}: Props): React.Node {
  const dispatch = useDispatch()
  const resourceSettings = useSelector((state) => state.packet.resourceSettings)

  const setExtraContexts = React.useCallback(
    (extraContext) => {
      const values = extraContext?.[contextNames?.customNotifications]?.values
      if (!values) return

      dispatch(setResourceSettings(values))
    },
    [dispatch]
  )

  const handleSetIsDirty = React.useCallback(
    (isDirty) => {
      dispatch(setIsDirty(isDirty))
    },
    [dispatch]
  )

  return children({
    extraContexts: {
      [contextNames?.customNotifications]: {
        values: { ...(resourceSettings || {}) },
      },
    },
    setExtraContexts,
    setIsDirty: handleSetIsDirty,
  })
}

export default FormBuilderSettingsCustomInvitePacketConsumer
